import { DestroyRef, Directive, ElementRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent, map } from 'rxjs';

@Directive({
  selector: '[nkOnResize]',
  standalone: true,
})
export class OnResizeDirective implements OnInit {
  @Output() public readonly nkOnResize = new EventEmitter<DOMRect>();
  @Output() public readonly nkOnInitSize = new EventEmitter<DOMRect>();

  private _destroy = inject(DestroyRef);

  constructor(private _element: ElementRef) {}

  public ngOnInit(): void {
    if (this.nkOnInitSize) {
      const element = this._element.nativeElement as HTMLElement;
      this.nkOnInitSize.emit(element.getBoundingClientRect());
    }
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(100),
        map(() => {
          const element = this._element.nativeElement as HTMLElement;
          return element.getBoundingClientRect();
        }),
        takeUntilDestroyed(this._destroy),
      )
      .subscribe((rect) => {
        this.nkOnResize.emit(rect);
      });
  }
}
